import {
  ApiKeysOverview,
  CancelPaymentOrderOverview,
  CreatePaymentOrderOverview,
  GetPaymentByOrderIdOverview,
  GetPaymentByReferenceIdOverview,
  SdkOverview,
  WebhookPaymentOrder,
  WebhookSettlementAccount,
  WebhooksOverview
} from '@images';

import { DOCS } from '@constants/routes';

export const coFeeApiDetails = [
  {
    id: 'create-payment-order',
    title: 'Create a Payment Order',
    desc: 'This endpoint is used to create a new payment order. A merchant initiates a payment request by providing order details, customer information, and optional notification preferences.',
    route: DOCS.CREATE_PAYMENT_ORDER,
    imageSrc: CreatePaymentOrderOverview
  },
  {
    id: 'get-payment-order-by-id',
    title: 'Get Payment by Order ID',
    desc: 'Retrieves the details of a payment order using its unique cofee order-id. Can be used  to check the payment status of a previously created order.',
    route: DOCS.GET_PAYMENT_ORDER_BY_ORDER_ID,
    imageSrc: GetPaymentByOrderIdOverview
  },
  {
    id: 'get-payment-order-by-reference-id',
    title: 'Get Payment by Reference ID',
    desc: 'Fetches an order based on a unique reference-id assigned by the merchant. Can be used  to retrieve an order using an internal reference.',
    route: DOCS.GET_PAYMENT_ORDER_BY_REFERENCE_ID,
    imageSrc: GetPaymentByReferenceIdOverview
  },
  {
    id: 'cancel-payment-order',
    title: 'Cancel a Payment Order',
    desc: 'Cancels a pending payment order. If the order has already been completed, it cannot be canceled',
    route: DOCS.CANCEL_PAYMENT_ORDER,
    imageSrc: CancelPaymentOrderOverview
  }
];

export const coFeeDocSections = [
  {
    id: 'api',
    title: 'API',
    desc: 'Authenticate with API keys and use the CoFee REST APIs to create, fetch, and cancel payment orders from your backend.',
    route: DOCS.API_KEYS,
    imageSrc: ApiKeysOverview
  },
  {
    id: 'sdk',
    title: 'SDK',
    desc: 'Collect payments inside your own website or app with the CoFee Checkout Web and Flutter SDKs.',
    route: DOCS.SDK,
    imageSrc: SdkOverview
  },
  {
    id: 'webhooks',
    title: 'Webhooks',
    desc: 'Receive real-time notifications of events that occur in the CoFee system. Configure webhooks to get notified for specific events.',
    route: DOCS.WEBHOOKS,
    imageSrc: WebhooksOverview
  }
];

export enum CoFeeApiDetails {
  POST = 'POST',
  GET = 'GET',
  PATCH = 'PATCH'
}

export const apiMethodColorMapper: Record<CoFeeApiDetails, string> = {
  [CoFeeApiDetails.POST]: 'bg-[#186FAF]',
  [CoFeeApiDetails.GET]: 'bg-[#2F8132]',
  [CoFeeApiDetails.PATCH]: 'bg-[#BF581D]'
};

export const WebhooksEvents = [
  {
    id: 'payment-order',
    label: 'Payment Order',
    desc: 'Get notified when a payment order is created, paid, failed, or cancelled.',
    descriptionUrl: '/webhook-events/payment-order.yaml',
    route: DOCS.WEBHOOK_PAYMENT,
    imageSrc: WebhookPaymentOrder
  },
  {
    id: 'settlement-account',
    label: 'Settlement Account',
    desc: 'Get notified when a settlement account is created or its status changes.',
    descriptionUrl: '/webhook-events/settlement-account.yaml',
    route: DOCS.WEBHOOK_ACCOUNT_SETTLEMENT,
    imageSrc: WebhookSettlementAccount
  }
];
